import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FooterLinks } from './FooterLinks';
import { AllRightsReserved } from './AllRightsReserved';
import scss from './Footer.module.scss';
export const Footer = ({ className = '' }) => (_jsxs("footer", Object.assign({ className: `${scss.footer} ${className}` }, { children: [_jsx(FooterLinks, { mode: "light" }), _jsx(AllRightsReserved, { mode: "light" })] })));
